export const useDropdownSelection = () => {
  return '$surface_bright';
};
